// Per the design spec, each item is: Fill width, Hug 30px height (5px top/bottom
// padding), 12px left/right padding, 8px radius, 12px icon↔label gap.
// Typography: 14px / weight 500 / 20px line-height / 0 letter-spacing, colour
// #0F172A (slate-900) in light, near-white in dark.
// NOTE: use the `text-sm/[36px]` shorthand — the standalone `text-sm` utility
// also sets its own line-height (20px), which overrides a separate
// `leading-[36px]`. Combining size + line-height in one utility makes the 36px
// line-height actually apply.

// Here updated css to match the ui with figma
export const MENU_ITEM_CLASS =
  "flex items-center justify-start py-[5px] px-3 rounded-lg text-sm/[30px] font-medium tracking-normal text-slate-900 cursor-pointer w-full hover:bg-gray-100 focus-visible:bg-gray-100 dark:text-gray-100 dark:hover:bg-gray-600 focus:outline-none dark:hover:text-white dark:focus-visible:bg-gray-600 dark:focus-visible:text-white";

export const MENU_ITEM_ICON_CLASS = "mr-3 h-5 w-5 shrink-0";

export const MENU_ITEM_VALUE_CLASS =
  "ms-auto flex items-center gap-1.5 text-sm font-medium text-gray-500 dark:text-gray-400";

// Container width per the design spec (Fixed 280px).
export const MENU_PANEL_WIDTH_CLASS = "w-[280px]";

// Popup container matches the Figma spec exactly: 280px wide, 12px radius,
// 1px #E2E8F0 border, 10px padding, white bg and a soft 0/8/24 shadow at
// #0F172A / 5.88%.
export const MENU_DROPDOWN_THEME = {
  // Items <ul> — flowbite renders children in <ul className={theme.content}> (a
  // TOP-LEVEL key). Drop its default `py-1` so the 10px container padding on
  // floating.base is the exact padding.
  content: "py-0 focus:outline-none",
  floating: {
    base: `z-50 ${MENU_PANEL_WIDTH_CLASS} rounded-xl p-2.5 divide-y divide-gray-100 dark:divide-gray-600 shadow-[0_8px_24px_0_rgba(15,23,42,0.06)] focus:outline-none`,
    // Border + background colours (overrides flowbite defaults to hit #E2E8F0).
    style: {
      auto: "border border-[#E2E8F0] bg-white text-gray-900 dark:border-gray-600 dark:bg-gray-800 dark:text-white",
    },
    item: {
      base: MENU_ITEM_CLASS,
      // Enlarge the flowbite-rendered item icons (Profile, Log out, …) to match.
      icon: "mr-3 h-5 w-5 shrink-0",
    },
  },
};
